<!--
  --
  -- 料金カード
  --
  -->
<template>
  <v-card>
    <v-card-title>お支払い</v-card-title>

    <v-card-text>
      <!-- お支払い方法 -->
      <div class="c-confirm-pay mb-8">
        <!-- 現地支払 -->
        <template v-if="pay.type === PAYTYPE_SPOT">
          <p>料金はお引渡しの際、店頭にてお支払い下さい。</p>
        </template>

        <!-- カード支払 -->
        <template v-if="pay.type === PAYTYPE_CARD">
          <p>次のクレジットカードで決済させて頂きます。</p>

          <v-sheet outlined rounded class="pa-4">
            <div class="d-flex flex-wrap font-weight-bold">
              <div>{{pay.cardNo}}</div>
              <div class="ml-auto">{{pay.expire | timeformat('m/Y')}}</div>
            </div>
          </v-sheet>
        </template>
      </div>

      <!-- 料金 -->
      <c-data-row label="基本料金" :charge="charge.basic"/>
      <c-data-row label="追加料金" :charge="charge.additional"/>

      <template v-if="coupon">
        <c-data-row label="割引"/>
        <c-data-row :indent="1" :label="coupon.name" :charge="-coupon.value"/>
      </template>

      <c-divider/>
      <c-total-row label="合計 (税込)" :charge="charge.total"/>
    </v-card-text>
  </v-card>
</template>

<style lang="scss">
.c-confirm-pay {
  p:last-child {
    margin-bottom: 0
  }
}
</style>

<script>
import CDataRow from './CDataRow'
import CTotalRow from './CTotalRow'
import CDivider from './CDivider'

import * as C from '@/consts'

export default {
  name: 'CChargeCard',
  components: {
    CDataRow,
    CTotalRow,
    CDivider
  },

  data: () => ({
    PAYTYPE_SPOT: C.PAYTYPE_SPOT,
    PAYTYPE_CARD: C.PAYTYPE_CARD
  }),

  computed: {
    charge () {
      return this.getters['book/charge']
    },

    coupon () {
      const coupon = this.getters['book/coupon']
      console.log(coupon)
      return this.getters['book/coupon']
    },

    pay () {
      return this.getters['book/pay']
    },

    payType () {
      switch (this.pay.type) {
        case C.PAYTYPE_CARD:
          return 'カード支払'
      }
      return '現地支払'
    }
  }
}
</script>
